const sendToTelegram = (location, action = 'Click "Trải Nghiệm Ngay"') => {
  try {
    const telegramApiUrl = process.env.REACT_APP_TELEGRAM_API_URL;
    const chatId = process.env.REACT_APP_TELEGRAM_CHAT_ID;

    console.log("11111111");

    if (!telegramApiUrl || !chatId) {
      console.warn("Thiếu thông tin cấu hình Telegram Bot");
      return;
    }

    const message = `🔔 ${action} tại: ${location}
🕒 ${new Date().toLocaleString("vi-VN")}
🌐 ${window.location.href}`;

    fetch(telegramApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        chat_id: chatId,
        text: message,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Đã gửi thông báo đến Telegram:", data);
      })
      .catch((error) => {
        console.error("Lỗi khi gửi thông báo đến Telegram:", error);
      });
  } catch (error) {
    console.error("Lỗi khi gửi thông báo đến Telegram:", error.message);
  }
};
const sendPointPurchaseNotification = async (
  userId,
  pointPackage,
  totalPoints
) => {
  try {
    const botToken = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
    const chatId = process.env.REACT_APP_TELEGRAM_CHAT_ID;

    if (!botToken || !chatId) {
      console.warn("Thiếu thông tin cấu hình Telegram Bot");
      return false;
    }

    const currentTime = new Date(
      new Date().getTime() + 7 * 60 * 60 * 1000
    ).toLocaleString("vi-VN");

    const message = `💰 Mua điểm thành công!
ID: ${userId}
Gói: ${pointPackage.name}
+${pointPackage.points} điểm | Tổng: ${totalPoints}
Giá: ${pointPackage.price}đ
🕒 ${currentTime}`;

    const telegramApiUrl = `https://api.telegram.org/bot${botToken}/sendMessage`;

    await fetch(telegramApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        chat_id: chatId,
        text: message,
      }),
    });

    return true;
  } catch (telegramError) {
    // logErrorToDatabase(telegramError, {
    //   functionName: "sendPointPurchaseNotification",
    //   userId,
    //   packageName: pointPackage?.name,
    // });
    console.error("Lỗi khi gửi thông báo Telegram:", telegramError);
    return false;
  }
};

const sendPostReportNotification = async (reportData) => {
  try {
    const chatId = process.env.REACT_APP_TELEGRAM_CHAT_ID;

    if (!chatId) {
      console.warn("Thiếu thông tin cấu hình Telegram Bot");
      return false;
    }

    const currentTime = new Date(
      new Date().getTime() + 7 * 60 * 60 * 1000
    ).toLocaleString("vi-VN");

    const message = `🚨 BÁO CÁO LỖI BÀI VIẾT
📝 Loại lỗi: ${reportData.errorType}
👤 User ID: ${reportData.userId}
🌐 Ngôn ngữ: ${reportData.language}
📏 Độ dài: ${reportData.postLength}
🎨 Phong cách: ${reportData.postStyles}
🔗 URL tham khảo: ${reportData.referenceUrl || "Không có"}
💬 Mô tả chi tiết: ${reportData.description}
📱 User Agent: ${reportData.userAgent}
🕒 Thời gian: ${currentTime}
---
📄 Tiêu đề bài viết: ${reportData.postTitle}
📝 Nội dung (300 ký tự đầu): ${reportData.postContent?.substring(0, 300)}...`;

    const telegramApiUrl = process.env.REACT_APP_TELEGRAM_API_URL;

    const response = await fetch(telegramApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        chat_id: chatId,
        text: message,
      }),
    });

    if (response.ok) {
      console.log("✅ Đã gửi báo cáo lỗi đến Telegram thành công");
      return true;
    } else {
      console.error("❌ Lỗi khi gửi báo cáo đến Telegram", response.statusText);
      return false;
    }
  } catch (error) {
    console.error("❌ Lỗi khi gửi báo cáo đến Telegram:", error);
    return false;
  }
};

export {
  sendToTelegram,
  sendPointPurchaseNotification,
  sendPostReportNotification,
};
